import React from 'react';

const stackGroups = [
    {
        category: "Frontend",
        title: "Interfaces for SaaS and operations",
        description: "Structured, maintainable frontends for dashboards, portals, workflow tools, and customer-facing products.",
        technologies: ["React", "Angular", "TypeScript", "Bootstrap", "Responsive UI"],
        accent: "blue"
    },
    {
        category: "Backend",
        title: "APIs, services, and business logic",
        description: "Secure application layers, integrations, background processing, and domain workflows built for long-term scale.",
        technologies: ["Node.js", ".NET", "REST APIs", "Microservices", "Auth"],
        accent: "teal"
    },
    {
        category: "Data & Cloud",
        title: "Production-ready infrastructure",
        description: "Databases, deployments, monitoring, and release foundations that keep products stable as usage grows.",
        technologies: ["SQL Server", "PostgreSQL", "MongoDB", "Azure", "AWS"],
        accent: "purple"
    },
    {
        category: "AI & Automation",
        title: "Intelligent workflow systems",
        description: "AI-enabled workflows, document handling, decision support, and internal automation connected to real business processes.",
        technologies: ["OpenAI APIs", "Workflow Automation", "Data Pipelines", "Integrations", "Reporting"],
        accent: "orange"
    }
];

const TechnologyStack = () => {
    return (
        <section id="technology" className="technology-section technology-lean py-5">
            <div className="container" data-aos="fade-up">
                <div className="row g-4 align-items-start">
                    <div className="col-lg-4">
                        <div className="section-intro-sticky">
                            <span className="section-kicker">Technology Stack</span>
                            <h2 className="section-title fw-bold text-start">Modern tools, selected for durable systems.</h2>
                            <p className="section-subtitle text-muted text-start mb-0">
                                Anmatics uses proven technologies to build maintainable products, not experimental stacks that create future risk.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="technology-grid">
                            {stackGroups.map((group) => (
                                <article className={`technology-card technology-card-${group.accent}`} key={group.category}>
                                    <div className="technology-card-header">
                                        <span className="technology-accent"></span>
                                        <span className="technology-category">{group.category}</span>
                                    </div>
                                    <h3 className="technology-title">{group.title}</h3>
                                    <p className="text-muted mb-0">{group.description}</p>
                                    <div className="technology-tags">
                                        {group.technologies.map((technology) => (
                                            <span key={technology}>{technology}</span>
                                        ))}
                                    </div>
                                </article>
                            ))}
                        </div>
                        <div className="technology-note">
                            <strong>Stack decisions stay practical.</strong>
                            <span>We choose technology based on product goals, team ownership, performance needs, hosting model, and long-term maintenance cost.</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TechnologyStack;
